import React from 'react'
import cx from 'classnames'
import Form from '@rjsf/core'
import { FormValidation, RJSFValidationError, UiSchema } from '@rjsf/utils'
import { Dictionary } from '@feedyou/schema'
import styled from 'styled-components'

import '../design-system/FeedbotRjsfForm/styles.css'
import CollapsibleObject from './CollapsibleObject'
import { getExtraErrors } from './utils'
import { scrollToFirstInvalidField } from './utils/scrollToFirstInvalidField'
import {
  CollapsibleFormContext,
  CollapsibleGroup,
  ExpandedFieldPerCollapsibleGroup,
  FieldName
} from './types'
import { OnFormDataChange } from '../modals/hooks'
import { FeedbotRjsfForm } from '../design-system/FeedbotRjsfForm'

interface Props {
  uiSchema: UiSchema
  schema: any
  formData: any
  className?: string
  validationErrorsByField?: Dictionary<string, string>
  onError?: (error: any) => any
  onSubmit: (event: any) => void
  validateSchema?: (formData: any, errors: FormValidation) => FormValidation
  liveValidate?: boolean
  onChange?: OnFormDataChange<any>
  submitButtonRef: React.RefObject<HTMLButtonElement>
}

type State = { collapsibleGroups: ExpandedFieldPerCollapsibleGroup }

export default class CollapsibleForm extends React.Component<Props, State> {
  formComponentRef = React.createRef<Form<any>>()
  initialFormData = this.props.formData
  isFirstRenderCycle = true

  state: State = { collapsibleGroups: {} }

  componentDidMount() {
    this.isFirstRenderCycle = false
  }

  toggleFieldCollapse = (group: CollapsibleGroup, field: FieldName) => {
    this.setState(state => {
      const isFieldAlreadyExpanded = state.collapsibleGroups[group] === field

      return {
        collapsibleGroups: {
          [group]: isFieldAlreadyExpanded ? undefined : field
        }
      }
    })
  }

  getFormElement = (): HTMLFormElement | undefined => {
    return this.formComponentRef.current?.formElement?.current
  }

  handleError = (errors: RJSFValidationError[]) => {
    scrollToFirstInvalidField(this.getFormElement()!)
    this.props.onError?.(errors)
  }

  render() {
    const className = cx(this.props.className, 'reactjsonform')
    const {
      schema,
      uiSchema,
      liveValidate = true,
      validationErrorsByField = {},
      validateSchema,
      submitButtonRef
    } = this.props

    const formContext: CollapsibleFormContext = {
      initialFormData: this.initialFormData,
      collapsibleGroups: this.state.collapsibleGroups,
      toggleFieldCollapse: this.toggleFieldCollapse
    }

    return (
      <FeedbotRjsfForm
        liveValidate={liveValidate}
        noHtml5Validate
        schema={schema}
        onError={this.handleError}
        uiSchema={uiSchema}
        className={className}
        formData={this.props.formData}
        onSubmit={this.props.onSubmit}
        customValidate={validateSchema}
        extraErrors={getExtraErrors(validationErrorsByField)}
        onChange={({ formData }) => this.props.onChange?.(formData, this.isFirstRenderCycle)}
        formContext={formContext}
        fields={{ CollapsibleObject }}
        ref={this.formComponentRef}
      >
        <HiddenSubmitButton ref={submitButtonRef} />
      </FeedbotRjsfForm>
    )
  }
}

const HiddenSubmitButton = styled.button.attrs({ type: 'submit' })`
  display: none;
`
